const coins = require('../coins');
const REFERENCE_ASSETS = require('../reference-assets.json');

module.exports = [
  {
    dataIndex: 0,
    id: '3pool',
    name: '3pool',
    lpTokenInfo: {
        name: '3Ellipsis',
        symbol: '3Eps',
    },
    coingeckoInfo: {
        id: 'binance-usd',
        symbol: 'BUSD',
    },
    assets: 'BUSD+USDC+USDT',
    coins: [
        coins.busd,
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0x160CAed03795365F3A589f10C379FfA7d75d4E76',
        lpToken: '0xaF4dE8E872131AE328Ce21D909C74705d3Aaf452',
        gauge: '0xb5eb451137e90435449f4EB5680C404a355887a1',
    },
    hasNoGauge: true,
    pid: 1
},
{
    dataIndex: 1,
    id: 'fusdt',
    name: 'fusdt',
    lpTokenInfo: {
        name: 'fusdtCurve',
        symbol: 'fusdtCrv',
    },
    coingeckoInfo: {
        id: 'tether',
        symbol: 'USDT',
    },
    assets: 'fUSDT+3pool',
    isMetaPool: true,
    coins: [
        coins.fusdt,
        coins.trieps,
    ],
    metaCoins: [
        coins.busd,
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0x556ea0b4c06D043806859c9490072FaadC104b63',
        lpToken: '0x373410A99B64B089DFE16F1088526D399252dacE',
        gauge: '0xb5eb451137e90435449f4EB5680C404a355887a1',
        deposit: '0xf17814d515d3128753befd56cCeCEC2a0A41015F',
    },
    hasNoGauge: true,
    additionalRewards: [{
        name: 'ICE',
        amountDataKey: 'iceRewards',
        rewardTokenAddress: '0xf16e81dce15B08F326220742020379B855B87DF9',
        rewardTokenDecimals: 18,
        rewardTokenCoingeckoId: 'popsicle-finance',
    }],
    pid: 2
}, {
    dataIndex: 2,
    id: 'ren',
    name: 'ren',
    lpTokenInfo: {
        name: 'renCurve',
        symbol: 'renCrv',
    },
    coingeckoInfo: {
        id: 'renbtc',
        symbol: 'RENBTC',
        referenceAssetId: 'bitcoin',
    },
    assets: 'BBTC+renBTC',
    coins: [
        coins.btcb,
        coins.renbtc
    ],
    referenceAsset: REFERENCE_ASSETS.BTC,
    addresses: {
        swap: '0x2477fB288c5b4118315714ad3c7Fd7CC69b00bf9',
        lpToken: '0x2a435Ecb3fcC0E316492Dc1cdd62d0F189be5640',
    },
    hasNoGauge: true,
    pid: 3
},
{
    dataIndex: 3,
    id: 'dai',
    name: 'dai',
    lpTokenInfo: {
        name: 'daiCurve',
        symbol: 'daiCrv',
    },
    coingeckoInfo: {
        id: 'dai',
        symbol: 'DAI',
    },
    assets: 'dai+3pool',
    isMetaPool: true,
    coins: [
        coins.dai,
        coins.trieps,
    ],
    metaCoins: [
        coins.busd,
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0xc6a752948627bECaB5474a10821Df73fF4771a49',
        lpToken: '0x0BC3a8239B0a63E945Ea1bd6722Ba747b9557e56',
        gauge: '0xb5eb451137e90435449f4EB5680C404a355887a1',
        deposit: '0x2D0A931Dd088ea108a73901f83065DCA81ca474C',
    },
    hasNoGauge: true,
    pid: 4
},
{
    dataIndex: 4,
    id: 'tusd',
    name: 'tusd',
    lpTokenInfo: {
        name: 'tusdCurve',
        symbol: 'tusdCrv',
    },
    coingeckoInfo: {
        id: 'true-usd',
        symbol: 'TUSD',
    },
    assets: 'tusd+3pool',
    isMetaPool: true,
    coins: [
        coins.tusd,
        coins.trieps,
    ],
    metaCoins: [
        coins.busd,
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0x8D7408C2b3154F9f97fc6dd24cd36143908d1E52',
        lpToken: '0x052E566a25ACE8934Dcc52c41A27b04a7C7ECCbE',
        gauge: '0xb5eb451137e90435449f4EB5680C404a355887a1',
        deposit: '0xB4c0A71bFa5a5a4b1A096A7addb5025eAfAdA122',
    },
    hasNoGauge: true,
    pid: 5
}
];
